module.exports = __webpack_public_path__ + "media/images/swifticons/thumbs-up-unclicked-63c0cc4d90bb6fd0cce1d0e1a086cd0c.svg";